"use client";

import DesktopNav from "./DesktopNav";
import Links from "./links";
import MobileNavigation from "./MobileNav";
import {ColorPalette, HStack, Icon, LinkBox, LinkOverlay, Text} from "@chakra-ui/react";
import NextLink from "next/link";
import {ArrowRightIcon} from "@heroicons/react/20/solid";

const Banner = () => (
  <HStack bg="gray.800" bgGradient="grayBrand" borderBottom="1px solid black" justify="center" py={2} display="none">
    <LinkBox asChild>
      <HStack py={1} px={3} rounded="lg" color="white" className="group" _hover={{bg: "gray.700"}} cursor="pointer">
        <Text fontWeight="semibold" fontSize="sm">
          <LinkOverlay asChild>
            <NextLink href="/guide-to-dora-third-party-risk-management" />
          </LinkOverlay>
          Read our latest eGuide on DORA compliance
        </Text>
        <Icon
          asChild
          color="purple.300"
          _groupHover={{transform: "translateX(3px)", color: "purple.100"}}
          transition=".1s ease"
          size="md"
        >
          <ArrowRightIcon />
        </Icon>
      </HStack>
    </LinkBox>
  </HStack>
);

export const CUTOFF = "1030px";

export function Header({light, colorPalette = "blue"}: {light?: boolean; colorPalette?: ColorPalette}) {
  return (
    <>
      <Banner />
      <DesktopNav hideBelow={CUTOFF} links={Links} light={light} colorPalette={colorPalette} />
      <MobileNavigation hideFrom={CUTOFF} links={Links} light={light} colorPalette={colorPalette} />
    </>
  );
}
